module.exports = __webpack_public_path__ + "static/media/mz.e9e8b6c4.webp";